import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree
  } from '@angular/router';
import { AuthenticationService } from './../../authentication/authentication.service';
import { environment } from '../../../../environments/environment';
import { Injectable } from '@angular/core';
import { LocalStorageService } from '../../services/local-storage/local-storage.service';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { RoutingPath } from './../../../configs/routing-path';
import { ContentManagerService } from '../../services/content-manager/content-manager.service';

@Injectable({
  providedIn: 'root'
})
export class NoLoggedGuard implements CanActivate {

  constructor(
    private _router: Router,
    private _storage: LocalStorageService,
    private _auth: AuthenticationService,
    private contentManagerService:ContentManagerService) {
  }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    this._storage.setItem(environment.LOCAL_STORAGE.LOGIN_USER_TOKEN, next.params.idToken);

    return this._auth.validateAuthToken()
      .pipe(
        map((result) => {
          if (result) {
            this.contentManagerService.getAllItems().subscribe(res=>{
              this._router.navigateByUrl(RoutingPath.appRouting.components.dashboard.path + '/' + RoutingPath.appRouting.components.dashboard.pages.home.path);
              return true;
            });
          } else {
            location.href = environment.SEGURIDAD.SSO_URL;
            return false;
          }
        })
      );
  }
}
